import { Expose } from 'class-transformer'

export class SignInWithSocialNetworkServiceType {
  @Expose() id: number

  @Expose() email: string

  @Expose() displayName: string
}
